import {useSortable} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";

export default function SortableItem({ id, children, className}) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        background: isDragging ? "#e0e0e0" : "#fff",
        borderRadius: "4px",

    };

    return (
        <div ref={setNodeRef} className={className}  style={style}>
            <div className="flex-grow-1 d-flex">{children}</div>
            <span {...attributes} {...listeners} className="drag-handle me-2 ms-3" style={{cursor: "grab"}}>
                <i className="fa-solid fa-grip-vertical"></i>
            </span>
        </div>

    );
}
